// File: cgp-authentication.js
// Author: Brandon Shreve
// Date: 1/9/2017
// Desc: Authentication module that handles integrating with CGP Authentication.
//       Handles redirecting to GAME login page and reading the cookie that has our authorization token.
//       Has methods to get the authorization token as well as the logged in user's information.
// Other Contributors: Joseph M Diaz

import { config } from '../config/config';
import { cgpCookieHelper } from './cgp-cookie-helper';
import { cgpSecurityUrls, cgpLoginUrls } from 'src/config/config.base';
import { getEnv, setUserProfile, getUserProfile } from './utility';

function updateLoading(msg, token = '') {
    const x = document.getElementById('loading');

    const user = getUserInfo();

    if (!token || !user) return;
    x.firstElementChild.firstElementChild.lastElementChild.lastElementChild.innerHTML = user.cn;
    x.firstElementChild.className = 'user';
    x.lastElementChild.innerHTML = msg;
}

function updateMescLoading(msg) {
    var x = document.getElementById('loading');
    x.lastElementChild.innerHTML = msg;
}

function singleSignOnRedirect(redirectLink: any) {
    const env = getEnv();
    const cgpLoginUrl = cgpLoginUrls[env] + encodeURIComponent(redirectLink);
    //const token = window.location.search.replace('?cgp-token=', '');

    //if (token && token !== '') cgpCookieHelper.setAuthCookie(token.replace(/^\s*:\s*Bearer\s*/, ""));
    updateLoading('Logging in...');

    window.history.pushState({}, document.title, redirectLink);
    window.location.replace(cgpLoginUrl);
}

function validateToken(callback: Function) {
    let token: string = getAuthToken();
    const location = window.location.href.split('?')[0];

    updateLoading('Validating Token...', token);
    if (token) {
        //if (!token.startsWith('Bearer')) cgpCookieHelper.setAuthCookie(token);
        const env = getEnv();
        const url = cgpSecurityUrls[env] + 'validateToken';
        const http = new XMLHttpRequest();
        window.history.pushState({}, document.title, location);

        http.open('POST', url, true);
        http.setRequestHeader('Content-type', 'application/json');
        http.setRequestHeader('Authorization', token);
        http.onreadystatechange = function () {
            if (http.readyState !== XMLHttpRequest.DONE) {
                return;
            }

            const profile = http.getResponseHeader(config.authentication.userInfoCookie);

            if (http.status === 200 || http.status === 0) {
                setUserProfile(profile);
                if (callback) { callback(); }
            } else {
                singleSignOnRedirect(location);
            }
        };
        http.send();
    }
    else {
        singleSignOnRedirect(location);
    }
}

function refreshToken(callback: Function) {
    const token = getAuthToken();
    const env = getEnv();
    const url = cgpSecurityUrls[env] + 'refreshToken';
    const http = new XMLHttpRequest();

    http.open('POST', url, true);
    http.setRequestHeader('Content-type', 'application/json');
    http.setRequestHeader('Authorization', token);

    http.onreadystatechange = function () {
        if (http.readyState !== XMLHttpRequest.DONE) {
            return;
        }

        if (http.status === 200) {
            //const newToken = http.getResponseHeader(config.authentication.authenticationCookie);
            //cgpCookieHelper.setAuthCookie(newToken.replace(/^\s*:\s*Bearer\s*/, ""));
            if (callback) { callback(null, 'success'); }
        }
        else {
            if (callback) { callback('error', null); }
        }
    };
    http.send();
}

function invalidateToken(callback: Function) {

    cgpCookieHelper.deleteAuthCookie();
}

function parseToken(token) {
    if (token) {
        const parsedToken = token.replace('Bearer_', 'Bearer ');
        return parsedToken;
    }
    else {
        return '';
    }
}

function getAuthToken() {
    const token = cgpCookieHelper.retrieveCookie(config.authentication.authenticationCookie);
    return parseToken(token);
}

function getUserInfo() {
    let userInfo = cgpCookieHelper.retrieveCookie(config.authentication.userInfoCookie);

    if (!userInfo) {
        userInfo = getUserProfile();
    }

    try {
        const profile = JSON.parse(userInfo);
        return profile.length ? JSON.parse(profile) : profile;
    } catch (e) { }
}

export const cgpAuthentication = {
    singleSignOnRedirect: singleSignOnRedirect,
    getAuthToken: getAuthToken,
    getUserInfo: getUserInfo,
    validateToken: validateToken,
    invalidateToken: invalidateToken,
    refreshToken: refreshToken,
    updateMescLoading: updateMescLoading
}
